import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    versionPrefixLabel: string;
    commentCountLabel: ({ count }: {
        count: number;
    }) => string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** The prefix label to display before the version number */
            versionPrefixLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Thumb.versionPrefixLabel?c=1wivil9uz1glq", defaultMessage: "V" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Accessible label for the comment count indicator (e.g. "5 comments"). */
            commentCountLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => ({ count }: {
                        count: number;
                    }): string => __intl__.intl().formatMessage({ id: "Thumb.commentCountLabel?c=9w6ib6tjh6dc", defaultMessage: "{count, plural, one {1 comment} other {{count} comments}}" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
